import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useReducedMotion } from '../../../theme/hooks.js';
import type { IconProps } from '../../primitives/types.js';

/** Redo — arrow arcs forward. Arrow tip nudges along its path to hint
 *  "redo this step". Mirror of IcnUndo so the pair reads as a set. */
export function IcnRedo(props: IconProps): ReactNode {
  const reduced = useReducedMotion();
  return (
    <Svg {...props} iconName="redo">
      <path d="M14 8a5 5 0 0 1 -5 5H4.5" />
      <polyline points="12 4 14 6 12 8" />
      <line x1="4" y1="8" x2="14" y2="8" strokeOpacity="0">
        {!reduced && (
          <animate
            attributeName="stroke-opacity"
            values="0;0.45;0"
            keyTimes="0;0.5;1"
            dur="2.4s"
            repeatCount="indefinite"
          />
        )}
      </line>
    </Svg>
  );
}
